import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface IInfoCard {
  secondary?: boolean
  tertiary?: boolean
  filter?: string | false
  width?: number
  quaternary?: boolean
  large?: boolean
  green?: boolean
  autoHeigth?: boolean
  textWhite?: boolean
  disabled?: boolean
  pic?: boolean
  backgroundColor?: string
}

export default styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: end;
  box-sizing: border-box;
  background: ${(props: IInfoCard & { theme: any }) => {
    if (props.backgroundColor) return props.theme.colors.primary
    if (props.green) return Theme.pallete.QUINARY
    if (props.secondary) return props.theme.colors.primary
    if (props.quaternary) return `${Theme.pallete.PRIMARY}`
    if (props.tertiary) return `${Theme.pallete.QUINARY}`
    return `${Theme.pallete.SECONDARY}`
  }};
  opacity: ${(props: IInfoCard) => {
    if (props.disabled) return `0.5`
    return `1`
  }};
  width: ${(props: IInfoCard) => {
    if (props.width) return `${props.width}px`
    if (props.large) return '304px'
    return `auto`
  }};
  min-width: 120px;
  height: ${(props: IInfoCard) => {
    if (props.autoHeigth) return '94.5px'
    return '114px'
  }};
  padding: 16px 24px 24px;
  border-radius: 5px;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);

  @media only screen and (min-width: 1441px) {
    height: ${(props: IInfoCard) => {
      if (props.autoHeigth) return '104px'
      return '128px'
    }};
    width: ${(props: IInfoCard) => {
      if (props.width) return `${props.width}px`
      if (props.large) return '342px'
      return `auto`
    }};
    min-width: 120px;
    padding: 29px;
  }
  .ic-icon {
    width: ${(props: IInfoCard) => {
      if (props.pic) return '24px'
      return `20px`
    }};
    height: ${(props: IInfoCard) => {
      if (props.pic) return '24px'
      return `20px`
    }};
    border-radius: ${(props: IInfoCard) => {
      if (props.pic) return '50%'
      return `0`
    }};
    object-fit: cover;
    filter: ${(props: IInfoCard & { theme: any }) => {
      if (props.secondary) return props.theme.filters.primaryIcon
      if (props.textWhite)
        return 'invert(100%) sepia(100%) saturate(0%) hue-rotate(308deg) brightness(107%) contrast(101%)'
      if (props.quaternary)
        return `invert(100%) sepia(100%) saturate(2%) hue-rotate(131deg) brightness(101%) contrast(101%)`
      if (props.tertiary)
        return `invert(100%) sepia(100%) saturate(0%) hue-rotate(308deg) brightness(107%) contrast(101%)`
      if (props.filter) return `${props.filter}`
      return ``
    }};

    @media only screen and (min-width: 1441px) {
      width: 21px;
      height: 21px;
    }
  }

  .ic-content {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  .ic-value {
    color: ${(props: IInfoCard & { theme: any }) => {
      if (props.secondary) return props.theme.colors.primaryBtnTxt
      if (props.textWhite) return Theme.pallete.SECONDARY
      if (props.tertiary) return `${Theme.pallete.SECONDARY}`
      if (props.quaternary) return `${Theme.pallete.SECONDARY}`
      return `${Theme.pallete.PRIMARY}`
    }};
    overflow: hidden;
    margin-left: 8px;
    text-overflow: ellipsis;
    width: 100%;
    line-height: normal;
    white-space: nowrap;
    font-family: ${Theme.fontFamily.SECONDARY};
    font-weight: 700;
    letter-spacing: 0.22px;
    font-size: 16px;
  }

  .ic-title {
    color: ${(props: IInfoCard & { theme: any }) => {
      if (props.secondary) return props.theme.colors.primaryBtnTxt
      if (props.textWhite) return Theme.pallete.SECONDARY
      if (props.tertiary) return `${Theme.pallete.SECONDARY}`
      if (props.quaternary) return `${Theme.pallete.SECONDARY}`
      return `${Theme.pallete.PRIMARY}`
    }};
    font-family: ${Theme.fontFamily.SECONDARY};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
    white-space: nowrap;
  }
`
